import { ArrowRight, PageHero } from '../../components/Layout';
import { DETAIL_SERVICES } from '../../data/siteData';

export default function ServicesPage({ onNavigate }) {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="A complete customer support layer for modern businesses."
        text="Choose one service or combine channels into a managed support desk that covers calls, bookings, written enquiries, and overflow demand."
        backgroundImage="../../abouthero.webp"
      />
      <div className="section-pad">
        <div className="detail-list">
          {DETAIL_SERVICES.map((service) => (
            <article className="detail-card" key={service.title}>
              <div>
                <p className="eyebrow">ClearDesk service</p>
                <h2>{service.title}</h2>
                <p>{service.summary}</p>
              </div>
              <ul>
                {service.points.map((point) => <li key={point}>{point}</li>)}
              </ul>
            </article>
          ))}
        </div>
        <div className="support-strip">
          <div>
            <h2>Need a custom support mix?</h2>
            <p>We can shape call handling, booking support, inbox coverage, and out-of-hours response around your actual workflow.</p>
          </div>
          <button className="btn primary" onClick={() => onNavigate('/contact')}>
            Discuss requirements <ArrowRight />
          </button>
        </div>
      </div>
    </>
  );
}
